import { CompanyAPI } from '@api';

const getUseTermsBanner = async () => CompanyAPI.getUseTermsBanner()
  .then(({ data }) => data.term)
  .catch((error) => Promise.reject(error.response));

export { getUseTermsBanner };
